import { render, staticRenderFns } from "./BackorderItem.vue?vue&type=template&id=0d540c18&scoped=true&"
import script from "./BackorderItem.vue?vue&type=script&lang=js&"
export * from "./BackorderItem.vue?vue&type=script&lang=js&"
import style0 from "./BackorderItem.vue?vue&type=style&index=0&id=0d540c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d540c18",
  null
  
)

export default component.exports